import { Navigate } from 'react-router';

import { useValidateQuery } from 'src/apiClients';
import { Layout } from 'src/components/layout';
import { ROUTES } from 'src/utils/strings';

export const PerformLogin = () => {
    /*
     * Token gate for the app. By the time this renders, the AccessTokenGuard has
     * already let a stored token through, so we only validate it here: render the
     * app on success, otherwise hand off to /login. LoginForm owns the login entry
     * point from there (SSO redirect in production, legacy form otherwise), so the
     * SSO hand-off lives in a single place.
     */
    const { isSuccess, isError } = useValidateQuery(undefined);

    if (isError) {
        return <Navigate to={ROUTES.LOGIN} replace />;
    }

    if (isSuccess) {
        return <Layout />;
    }

    return null;
};
